import CuratedSongEntity from '../../entities/CuratedSongEntity'
import Repository from './Repository'

export default class CuratedSongRepository extends Repository {
  constructor(adapter) {
    super()
    this._adapter = adapter
  }

  addEntity(entity) {
    this.add(new CuratedSongEntity(entity))
  }

  getClassSong(classId) {
    let query = { id: classId }
    return this.find(query)
  }

  _mapFetchedDataToLayouts(fetchedData) {
    this._data = fetchedData.map(data => new CuratedSongEntity(data))
  }

  _mapFetchedDataToEntity(fetchedData) {
    if (fetchedData === [] || fetchedData === undefined) {
      return
    }
    if (Array.isArray(fetchedData)) {
      fetchedData.map(data => this.add(new CuratedSongEntity(data)))
    } else {
      this.add(new CuratedSongEntity(fetchedData))
    }
    return
  }

  // _mapperIn(data = {}) {
  // 	const mappedData = { id: data.id, title: data.title, description: data.description,
  // 		status: data.status, level: data.level, playListURL: data.playListURL}
  // 	const masterClass = new CuratedSongEntity(mappedData)
  // 	this._data.push(masterClass)
  // }
}
